import {
    AwesomeTableComponent,
    IColumnsProps,
    InputTextSearch,
} from "d-react-components";
import { debounce, filter, map } from "lodash";
import { useContext, useMemo, useState } from "react";
import { EquipmentStockAdjustmentDetailContext } from "../../../../context/equipment-stock-adjustment";
import Messages from "../../../../languages/Messages";
import ProductNameView from "../../../product/share/ProductNameView";

const EquipmentStockAdjustmentItems = () => {
    const { stockAdjustment } = useContext(
        EquipmentStockAdjustmentDetailContext
    );
    const [textSearch, setTextSearch] = useState<string>("");
    const proSource = useMemo(() => {
        const mappedPros = map(stockAdjustment?.equipments ?? [], (item) => ({
            ...(item?.equipment ?? {}),
            adjustment: item?.equipment ?? 0,
        }));
        if (textSearch) {
            return filter(mappedPros, (item) => {
                const { name, equipmentNo } = item;
                const text = textSearch?.toLocaleLowerCase?.();
                return (
                    name?.toLocaleLowerCase?.()?.indexOf(text) !== -1 ||
                    equipmentNo?.toLocaleLowerCase?.()?.indexOf(text) !== -1
                );
            });
        }
        return mappedPros;
    }, [textSearch, stockAdjustment?.equipments]);

    const columns: IColumnsProps = [
        {
            title: Messages.item,
            dataIndex: "",
            render: (service) => <ProductNameView product={service} />,
        },
        {
            title: Messages.quantity,
            dataIndex: "adjustment",
        },
    ];

    const onChangeSearch = debounce((event) => {
        const search = event.target.value;
        setTextSearch(search);
    }, 0);

    return (
        <div className="mt-3">
            <div className="flex-row-between-center">
                <label>{Messages.service}</label>
            </div>
            <InputTextSearch onChange={onChangeSearch} className="mt-3" />
            <AwesomeTableComponent
                columns={columns}
                dataSource={proSource}
                className="mt-3"
                pagination={false}
            />
        </div>
    );
};

export default EquipmentStockAdjustmentItems;
